function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, Object, status) {
    var h = require("panel").h;
    const {
      initial,
      clicked,
      complete,
      reset
    } = $component.states;
    return {
      value: (h("div", {
        "class": {
          'mp-share-button': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'mp-share-fade-out': status === clicked,
            'mp-share-fade-in-out': status === complete,
            'mp-share-fade-in': status === reset,
          }, {
            'mp-share-animations': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((((status) == (initial)) || ((status) == (clicked)) || ((status) == (reset))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: event => $helpers.handleClick(event),
                },
                "class": {
                  'mp-share-message': true,
                  'mp-share-click': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": {
                    icon: `share`
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-share-label': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Share");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) :
            (((status) == (complete))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-share-message': true,
                  'mp-share-success': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": {
                    icon: `checkmark`
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-share-label': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Link Copied!");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) :
            undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "status" in locals ? locals.status : typeof status !== "undefined" ? status : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;